const colors = {
  primaryColor: '#0a65cd',
  secondaryColor: '#215ED8',
  thirdColor: '#e510b0',
  whiteColor: '#ffffff',
  blackColor: '#000000',
  lightBlackColor: '#222222',
  lightGrayColor: '#f2f2f5',
  darkGrayColor: '#666666',
  mediumGrayColor: '#CCCCCC',
  errorColor: '#E74C3C',
};

export const theme = {
  colors: {
    ...colors,
    buttonTextColor: colors.whiteColor,
    buttonLightGrayColor: '#f3f4f6',
    disabledButtonColor: colors.mediumGrayColor,
    cardBackgroundColor: colors.whiteColor,
    cardBorderColor: '#e5e5eb',
    borderColor: colors.lightGrayColor,
    mainBackgroundColor: '#f3f3f3',
    fontBaseColor: colors.blackColor,
    transparentColor: 'transparent',
    ctaColor: colors.secondaryColor,
    listItemTitleColor: colors.blackColor,
    listItemSubtitleColor: colors.darkGrayColor,
  },
};
